import { render, staticRenderFns } from "./standardProducts.vue?vue&type=template&id=27c81a37&scoped=true"
import script from "./standardProducts.vue?vue&type=script&lang=ts"
export * from "./standardProducts.vue?vue&type=script&lang=ts"
import style0 from "./standardProducts.vue?vue&type=style&index=0&id=27c81a37&prod&lang=css"
import style1 from "./standardProducts.vue?vue&type=style&index=1&id=27c81a37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c81a37",
  null
  
)

export default component.exports